import api from '../utils/api';
import apiEndpoints from "../config/apiEndpoints";

const portalService = {
    getOwners: async (abortController) => {
        return await api.get(apiEndpoints.owners, abortController);
    },
    getUsers: async (abortController) => {
        return await api.get(apiEndpoints.users, abortController);
    },
    getOrdersCount: async(excludeGuest, abortController) => {
        return await api.get(`${apiEndpoints.bookings}/count?excludeGuests=${excludeGuest}`, abortController);
    },
    getOrders: async(excludeGuest, abortController) => {
        return await api.get(`${apiEndpoints.bookings}/all?excludeGuest=${excludeGuest}`, abortController);
    },
    deleteOrder: async (id, sub, abortController) => {
        return await api.delete(`${apiEndpoints.bookings}?id=${id}&sub=${sub}`, abortController);
    },
    getCities: async() => {
        return await api.get(`${apiEndpoints.cities}/all`);
    },
    getLocks: async() => {
        return await api.get(`${apiEndpoints.locations}/locks`);
    },
    addLock: async(newLock) => {
        return await api.post(`${apiEndpoints.locations}/locks`, newLock);
    },
    addLocation: async(itemLocation) => {
        return await api.post(apiEndpoints.locations, itemLocation);
    },
    addBox: async(item) => {
        return await api.post(`${apiEndpoints.locations}/items`, item);
    },
    getSchedules: async() => {
        return await api.get(`${apiEndpoints.locations}/items/schedules`);
    },
    addSchedule: async(schedule) => {
        return await api.post(`${apiEndpoints.locations}/items/schedules`, schedule);
    },
    addPrice: async(price) => {
        return await api.post(apiEndpoints.boxPrices, price);
    }
}

export default portalService;